export class BulletinSectionService {
  constructor(fetchData) {
    this.fetchData = fetchData;
  }

  // Get all sections for a bulletin
  async getAllSections(bulletinId, params = {}) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${bulletinId}/sections`,
      method: "GET",
      params,
    });
  }

  // Create new section
  async createSection(bulletinId, data) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${bulletinId}/sections`,
      method: "POST",
      data,
    });
  }

  // Get specific section
  async getSection(bulletinId, sectionId) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${bulletinId}/sections/${sectionId}`,
      method: "GET",
    });
  }

  // Update section
  async updateSection(bulletinId, sectionId, data) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${bulletinId}/sections/${sectionId}`,
      method: "PUT",
      data,
    });
  }

  // Delete section
  async deleteSection(bulletinId, sectionId) {
    return await this.fetchData({
      url: `ebulletin/bulletins/${bulletinId}/sections/${sectionId}`,
      method: "DELETE",
    });
  }
}
